import { combineReducers } from 'redux'

import applications from './applications/reducers'

const candidatesReducer = combineReducers({
  applications,
})

export default candidatesReducer
